import EditProductScreen from "../modules/product/EditProductScreen";

export default function EditProduct() {
  return (
    <>
      <EditProductScreen />
    </>
  )
}
